import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface Props {
  /** Number of skeleton bars to render. */
  rows?: number;
  className?: string;
  /** Individual bar height class. Defaults to `h-6`. */
  barClassName?: string;
}

// Standard loading pattern used across pages: N stacked Skeleton bars. Kept
// deliberately minimal — page-specific loading (e.g. dashboard cards)
// composes multiple LoadingStates rather than adding variants here.
export function LoadingState({ rows = 4, className, barClassName = 'h-6' }: Props) {
  return (
    <div
      className={cn('flex flex-col gap-2', className)}
      role="status"
      aria-label="Loading"
      data-testid="loading-state"
    >
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className={cn('w-full', barClassName)} />
      ))}
    </div>
  );
}
